import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {DialogBase} from "app/archivage/deposit/modal/dialog.base";

@Component({
  selector: 'app-incomplete',
  templateUrl: './incomplete.component.html',
  styleUrls: ['./incomplete.component.scss']
})

export class DialogIncompleteComponent extends DialogBase<DialogIncompleteComponent> implements OnInit {
  minLengthLabel = 3;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<DialogIncompleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(dialogRef, data);
  }

  _initForm(): void {
    this.dialogForm = this.formBuilder.group({
      message: ['', [Validators.required, Validators.minLength(this.minLengthLabel)]]
    });
  }
}
